import { getNamedAnalysis } from "routes/sfg20-admin/plugins/system-info/activity-tab/controller/get-named-analysis"
import React from "react"
import { AnalysisDonut } from "routes/sfg20-admin/plugins/system-info/activity-tab/graphs/analysis-donut"
import uniqolor from "uniqolor"
import { Grid2, Paper } from "@mui/material"
import { getGraphStyles } from "routes/sfg20-admin/plugins/system-info/activity-tab/graphs/graph-styles"

export function graphLoading() {}

export function BrowserStats({ reportDuration, granularity }) {
    const data =
        getNamedAnalysis.useResults("metric-summary", reportDuration, granularity, {
            event: "session-start",
            metrics: [{ metric: "browser", jsonPath: "$.browser" }],
        }) ?? {}

    if (!data.results) {
        const { size, graphPaperSx, graphGridSx } = getGraphStyles()

        return (
            <Grid2 size={size} sx={graphGridSx}>
                <Paper elevation={3} sx={graphPaperSx}>
                    Loading
                </Paper>
            </Grid2>
        )
    }

    const total = data.results.reduce((sum, { recordCount }) => sum + recordCount, 0)

    const graphData = {
        labels: data.results.map(({ browser }) => browser),
        datasets: [
            {
                data: data.results.map(({ recordCount }) => recordCount),
                backgroundColor: data.results.map(
                    ({ browser }) =>
                        uniqolor(browser, {
                            saturation: [75, 100],
                            lightness: [50, 70],
                        }).color
                ),
                borderColor: data.results.map(
                    ({ browser }) =>
                        uniqolor(browser, {
                            saturation: [55, 85],
                            lightness: [10, 30],
                        }).color
                ),
            },
        ],
        total,
    }

    return <AnalysisDonut title={`Browser Usage - Last ${reportDuration} day(s)`} data={graphData} />
}
